import RatingsAndReviews from 'components/ProductPage/RatingsAndReviews/RatingsAndReviews';
import { withRatingsAndReviewsProps } from 'viewModel/product/ratingsAndReviews/withRatingsAndReviewsProps';

export default withRatingsAndReviewsProps(RatingsAndReviews);
